<div class="content-box principal-content container">
    <div class="d-flex justify-content-center spinner-content" *ngIf="finding">
        <div class="py-5">
            <mat-spinner [diameter]="70" [strokeWidth]="2"></mat-spinner>
        </div>
    </div>
    <div class="row">
        <button mat-button class="btn-back" mat-raised-button (click)="volverHome()">
            <mat-icon aria-hidden="false" aria-label="keyboard_backspace">keyboard_backspace</mat-icon>
            {{ 'stt.boton.back' | translate }}
        </button>
    </div>
    <div class="content-box content-text">
        <div class="container content-box">
            <div class="banner-superior ">
                <div class="row">
                    <div class="col-md-4">
                        <p *ngIf="showTrans"class="page-title"><strong>{{ 'stt.home.transcription' | translate }}</strong> -
                            {{ dateCreation | date:"MMMM d, y" }}</p>
                        <p *ngIf="!showTrans"class="page-title"><strong>{{ 'stt.home.traduction' | translate }}</strong> -
                                {{ dateCreation | date:"MMMM d, y" }}</p>
                    </div>
                    <div class="col-md-8">
                        <button class="button-secondary see-editions" (click)="openModalAudio(dataResult[0])">
                            <mat-icon aria-hidden="false" aria-label="headset">headset</mat-icon>
                            {{ 'stt.audio.title' | translate }}
                        </button>

                        <button class="button-secondary see-editions" (click)="openModalEditions()">
                            <mat-icon aria-hidden="false" aria-label="remove_red_eye">remove_red_eye</mat-icon>
                            {{ 'stt.boton.previouseditions' | translate }}
                        </button>

                        <button class="button-secondary see-editions" (click)="DownloadPdf(idMeet)">
                            <mat-icon aria-hidden="false" aria-label="picture_as_pdf">picture_as_pdf</mat-icon>
                            PDF
                        </button>

                        <button class="button-secondary see-editions" (click)="DownloadWord(idMeet)">
                            <mat-icon aria-hidden="false" aria-label="description">description</mat-icon>
                            Word
                        </button>

                        <mat-form-field>
                            <mat-label>
                                <mat-icon aria-hidden="false" aria-label="flag">flag</mat-icon>{{ 'stt.dropdown.idiom' |
                                translate }}
                            </mat-label>
                            <mat-select [formControl]="idiomForm" (selectionChange)="changeShow($event)"
                                class="select-form language" form>
                                <mat-option *ngFor="let lista of idiomList" [value]="lista">{{lista}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="text-container">
                <div class="col-md-12" *ngIf="showFloor">
                    <table mat-table class="w-100" [dataSource]="dataResult" matSort aria-label="Elements">
                        <caption></caption>
                        <ng-container matColumnDef="transcription_Text"> {{ 'stt.modalNoti.close' | translate }}
                            <h2 mat-dialog-title *matHeaderCellDef class="principal-title">
                                {{ 'stt.transcription.title' | translate }} - {{ title }}
                            </h2>
                            <th scope="col"></th>
                            <td id="id-{{row.startTrack}}" mat-cell *matCellDef="let row">
                                <br>
                                <strong class="subtitles"> {{ 'stt.modalEdit.speaker' | translate }} : {{row.orador}} / {{ dateCreation | date:"MMMM d, y" }} / {{ row.startTrack | date:"HH:mm:ss" }}</strong><br>
                                <strong class="subtitles"> {{ 'stt.modalEdit.speakEdit' | translate }} : {{row.modifyBy}} / {{row.dateModify }}</strong><br>
                                <br>
                                <div *ngIf="idTrans == row.transcriptionId">
                                    <p id="p-{{row.startTrack}}" class="">{{row.transcription_Text}}</p><br>
                                </div>
                                <div *ngIf="idTrans != row.transcriptionId">
                                    <p id="p-{{row.startTrack}}">{{row.transcription_Text}}</p><br>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; let x = index; columns: displayedColumns;" [class.selected]="row.isSelected">
                        </tr>
                    </table>
                </div>

                <div class="col-md-12" *ngIf="showEsp">
                    <table mat-table class="w-100" [dataSource]="dataResult" matSort aria-label="Elements">
                        <caption></caption>
                        <ng-container matColumnDef="transcription_Text">
                            <h2 mat-dialog-title *matHeaderCellDef class="principal-title">
                                Traducción Reunión - {{ title }}
                            </h2>
                            <th scope="col"></th>
                            <td mat-cell *matCellDef="let row">
                                <br>
                                <strong class="subtitles"> {{ 'stt.modalEdit.speaker' | translate }} : {{row.orador}} / {{ dateCreation | date:"MMMM d, y" }} / {{ row.startTrack | date:"HH:mm:ss" }}</strong><br>
                                <strong class="subtitles"> {{ 'stt.modalEdit.speakEdit' | translate }} : {{row.modifyBy}} / {{row.dateModify }}</strong><br>
                                <br>
                                <div *ngIf="idTrans == row.transcriptionId">
                                    <p class="highlight">{{row.transcriptionEsp}}</p><br>
                                </div>
                                <div *ngIf="idTrans != row.transcriptionId">
                                    <p> {{row.transcriptionEsp}}</p><br>
                                </div>
                                <br>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.selected]="row.isSelected">
                        </tr>
                    </table>
                </div>

                <div class="col-md-12" *ngIf="showEng">
                    <table mat-table class="w-100" [dataSource]="dataResult" matSort aria-label="Elements">
                        <caption></caption>
                        <ng-container matColumnDef="transcription_Text">
                            <h2 mat-dialog-title *matHeaderCellDef class="principal-title">
                                Translation Meeting - {{ title }}
                            </h2>
                            <th scope="col"></th>
                            <td mat-cell *matCellDef="let row">
                                <br>
                                <strong class="subtitles"> {{ 'stt.modalEdit.speaker' | translate }} : {{row.orador}} / {{ dateCreation | date:"MMMM d, y" }} / {{ row.startTrack | date:"HH:mm:ss" }}</strong><br>
                                <strong class="subtitles"> {{ 'stt.modalEdit.speakEdit' | translate }} : {{row.modifyBy}} / {{row.dateModify}}</strong><br>
                                <br>
                                <div *ngIf="idTrans == row.transcriptionId">
                                    <p class="highlight">{{row.transcriptionEng}}</p>
                                </div>
                                <div *ngIf="idTrans != row.transcriptionId">
                                    <p>{{row.transcriptionEng}}</p>
                                </div>
                                <br>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.selected]="row.isSelected">
                        </tr>
                    </table>
                </div>
                <div class="col-md-12" *ngIf="showFra">
                    <table mat-table class="w-100" [dataSource]="dataResult" matSort aria-label="Elements">
                        <caption></caption>
                        <ng-container matColumnDef="transcription_Text">
                            <h2 mat-dialog-title *matHeaderCellDef class="principal-title">
                                Traduction réunionnaise - {{ title }}
                            </h2>
                            <th scope="col"></th>
                            <td mat-cell *matCellDef="let row">
                                <br>
                                <strong class="subtitles"> {{ 'stt.modalEdit.speaker' | translate }} : {{row.orador}} / {{ dateCreation | date:"MMMM d, y" }} / {{ row.startTrack | date:"HH:mm:ss" }}</strong><br>
                                <strong class="subtitles"> {{ 'stt.modalEdit.speakEdit' | translate }} : {{row.modifyBy}} / {{row.dateModify}}</strong><br>
                                <br>
                                <div *ngIf="idTrans == row.transcriptionId">
                                    <p class="highlight">{{row.transcriptionFra}}</p>
                                </div>
                                <div *ngIf="idTrans != row.transcriptionId">
                                    <p>{{row.transcriptionFra}}</p>
                                </div>
                                <br>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.selected]="row.isSelected">
                        </tr>
                    </table>

                </div>
                <div class="col-md-12" *ngIf="showPor">
                    <table mat-table class="w-100" [dataSource]="dataResult" matSort aria-label="Elements">
                        <caption></caption>
                        <ng-container matColumnDef="transcription_Text">
                            <h2 mat-dialog-title *matHeaderCellDef class="principal-title">
                                Tradução da reunião - {{ title }}
                            </h2>
                            <th scope="col"></th>
                            <td mat-cell *matCellDef="let row">
                                <br>
                                <strong class="subtitles"> {{ 'stt.modalEdit.speaker' | translate }} : {{row.orador}} / {{row.dateCreation }}</strong><br>
                                <strong class="subtitles"> {{ 'stt.modalEdit.speakEdit' | translate }} : {{row.modifyBy}} / {{row.dateModify}}</strong><br>
                                <br>
                                <div *ngIf="idTrans == row.transcriptionId">
                                    <p class="highlight">{{row.transcriptionPor}}</p>
                                </div>
                                <div *ngIf="idTrans != row.transcriptionId">
                                    <p>{{row.transcriptionPor}}</p>
                                </div>

                                <br>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.selected]="row.isSelected">
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>